<div class="add-contact-modal-container">
  <div class="modal-header-content text-center">
    <h2 class="modal-title" *ngIf="!keyContactModel.id">Add New Contact</h2>
    <h2 class="modal-title" *ngIf="keyContactModel.id > 0">Edit Contact</h2>
    <p class="modal-subtitle">
      Complete the fields below, then click {{ keyContactModel.id > 0 ? 'Save' : 'Add' }}.
    </p>
  </div>

  <div class="modal-body-content">
    <form [formGroup]="keyContactForm">
      <!-- Name Field -->
      <div class="form-group-custom">
        <label class="field-label">
          Name
          <span
            matTooltip="Enter first and last name"
            style="
              background-image: url('/assets/images/Vector.svg');
              background-repeat: no-repeat;
              background-size: auto;
              background-position: center;
              padding: 10px;
            "
          ></span>
        </label>
        <input
          type="text"
          class="custom-form-input"
          placeholder="first and last name"
          formControlName="name"
        />
        <div
          class="field-error-msg"
          *ngIf="keyContactForm.get('name').touched && keyContactForm.get('name').hasError('required')"
        >
          Name is required
        </div>
      </div>

      <!-- Email Field -->
      <div class="form-group-custom">
        <label class="field-label">
          Email
          <span
            matTooltip="Enter contact email address"
            style="
              background-image: url('/assets/images/Vector.svg');
              background-repeat: no-repeat;
              background-size: auto;
              background-position: center;
              padding: 10px;
            "
          ></span>
        </label>
        <input
          type="email"
          class="custom-form-input"
          placeholder="user@mcd.com"
          formControlName="email"
        />
        <div
          class="field-error-msg"
          *ngIf="keyContactForm.get('email').touched && keyContactForm.get('email').invalid"
        >
          {{ getEmailValidationErrorMessage() }}
        </div>
      </div>

      <!-- Content Area Field -->
      <div class="form-group-custom">
        <label class="field-label">
          Content Area
          <span
            matTooltip="Enter content area or department"
            style="
              background-image: url('/assets/images/Vector.svg');
              background-repeat: no-repeat;
              background-size: auto;
              background-position: center;
              padding: 10px;
            "
          ></span>
        </label>
        <input
          type="text"
          class="custom-form-input"
          placeholder="type..."
          formControlName="contentArea"
        />
        <div
          class="field-error-msg"
          *ngIf="keyContactForm.get('contentArea').touched && keyContactForm.get('contentArea').hasError('required')"
        >
          Content Area is required
        </div>
      </div>
    </form>
  </div>

  <!-- Action Buttons -->
  <div class="modal-footer-actions">
    <button type="button" class="btn-cancel-custom" (click)="activeModal.dismiss()">
      Cancel
    </button>
    <button
      type="button"
      class="btn-save-gold"
      [disabled]="keyContactForm.invalid"
      (click)="saveContact()"
    >
      {{ keyContactModel.id > 0 ? 'Save' : 'Add' }}
    </button>
  </div>
</div>
